import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NavitemCategoria } from '../../controls/navitem.categoria'
import { DialogOk } from '../../controls/dialog-ok/dialog.ok';
import { Router } from '@angular/router';
import { DadosService } from '../../db/dados.service';
import { SubCategorias, ISubCategorias } from '../../../../models/subCategorias.model';
import { AngularFirestore } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { MensagemDialog }   from '../../views/mensagem/mensagem';

@Component({
  selector: 'app-sidenav-list',
  templateUrl: './sidenav-list.component.html',
  styleUrls: ['./sidenav-list.component.css']
})
export class SidenavListComponent implements OnInit {
  @Output() closeSidenav = new EventEmitter<void>();
  fmensagem: string;
  step = 1;
  stepCateg = 0;
  subCategCodigo: string;
  subCategorias: any = [];
  subCategClass: SubCategorias;

  constructor(
    private route: Router, 
    private db: AngularFirestore, 
    private dialog: MatDialog,
    private dados: DadosService) {


      this.route.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
     }
      this.subCategClass = new SubCategorias(db, null);
  }

  ngOnInit() {
    this.fmensagem == "Escolha o categoria de produto desejado";
  }
  @Input()
  get config() {
    return this.dados.config;
  }

  onClose() {
    this.closeSidenav.emit();
  }
  showInfo(texto) {

  }
  doCategClick(x:number) {
    this.dados.regAnalytics(0,'acessos','categorias',1);
    this.dados.regAnalytics(0,'acessos','categorias'+x,1);
    this.route.navigate(['/prod_categ', Number(x)]);
    this.closeSidenav.emit();
  }
  doSubCategoriaClick(subCateg){
    this.dados.regAnalytics(0,'acessos','subCategorias',1);
    this.closeSidenav.emit();
    let sg = subCateg.codigo;
    this.dados.regAnalytics(0,'acessos','subCategorias'+sg,1);
    this.route.navigate(["/subCategoria", sg ]);
  }
  doFornecClick(x) {
    this.dados.regAnalytics(x,'publicidade','fornecedorMenu',1);
    this.closeSidenav.emit();
    this.route.navigate(['/fornecedor', x]);
  }

  setStep(v) {
    this.step = v;
  }
  getCategorias() {
    return this.dados.getCategorias();
  }
  setStepCateg(x) {
    this.subCategorias = [];
    this.stepCateg = x;
    if (x>=0) {
    let categ = this.dados.getCategorias()[x];
    if (categ) {
      this.subCategClass.snapshot(
        r => {
          return r.where('categoria', '==', Number(categ.codigo));
        }, d=>{
          this.subCategorias = d;
        }
      )
    }}

  }

  getFornecedores() {
    return this.dados.getFornecedores();
  }
  
  @Input()
  get mensagem() {
    return this.fmensagem;
  }
  set mensagem(v: string) {
    this.fmensagem = v;
  }

  showMessage(msg: string) {
    this.fmensagem = msg;
    return (msg != null) && (msg.length > 0);
  }

  doEnviarMensagem(){
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "450px";
    dialogConfig.minHeight = "250px";
    dialogConfig.data = {
      fornecedor:0 ,
      title: 'Enviar mensagem',
    };

    this.dialog.open(MensagemDialog, dialogConfig);  
  
  }


}
